import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { ToastService } from '@connect/shared/services/toast.service';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    public readonly isIframe = window !== window.parent && !window.opener;
    private componentDestroyed: Subject<void>;

    constructor(
        messageService: MessageService,
        toastService: ToastService
    ) {
        this.componentDestroyed = new Subject<void>();
        toastService.receiveMessages()
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe(m => messageService.add(m));
    }

    public ngOnDestroy(): void {
        this.componentDestroyed.next();
        this.componentDestroyed.complete();
    }
}
